import { productFruits } from 'product-fruits';

const code = process.env.VUE_APP_PRODUCT_FRUITS_ID;
let isEnabled = code !== '';
let isInited = false;

export function init(data) {
    if (!isEnabled || isInited) {
        return;
    }

    // TODO - date formatting like this should be moved to its own utility & improved (frontend app upgrade initiative)
    const signUpAt = (new Date(data.created_at * 1000)).toJSON();
    const lastLoginAt = (new Date(data.user_last_login * 1000)).toJSON();

    const attributes = {
        username: data.id,
        email: data.email,
        firstname: data.firstName,
        lastname: data.lastName,
        signUpAt,
        props: {
            signableRole: data.role,
            companyId: data.company_id,
            lastLoginAt,
        },
    };

    productFruits.init(code, 'en', attributes);

    isInited = true;

    // Helpscout beacon triggers for API driven list items
    productFruits.safeExec(() => {
        window.productFruits.api.checklists.listen('item-launched', (id, internalId) => {
            if (internalId === 'triggerhelp' && window.Beacon) {
                window.Beacon('article', '659ed51bce3e1e0eca456325');
                window.productFruits.api.checklists.markItemAsDone(internalId, true);
            }
        });
    });
}

export function destroy() {
    if (!isEnabled || !isInited || !window.productFruits) {
        return;
    }

    window.productFruits.services?.destroy();
}

export function identify(username) {
    if (!isEnabled || !isInited || !window.productFruits) {
        return;
    }

    window.productFruits.identifyUser({ username });
}

export function trackPageChange() {
    if (!isEnabled || !isInited || !window.productFruits) {
        return;
    }

    window.productFruits.pageChanged();
}

export function enable() {
    isEnabled = true;
}

export function disable() {
    isEnabled = false;
}
